import script from "./MindCollectNormal.vue?vue&type=script&setup=true&lang=js"
export * from "./MindCollectNormal.vue?vue&type=script&setup=true&lang=js"

import "./MindCollectNormal.vue?vue&type=style&index=0&id=adf0b812&lang=less"
import "./MindCollectNormal.vue?vue&type=style&index=1&id=adf0b812&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adf0b812"]])

export default __exports__